import { getCookies } from 'cookies-next'
import { getURLSearch } from 'lib/navigation/helpers/getURLSearch/getURLSearch'

export interface GetSourceParams {
  gclid?: Maybe<string>
  utm_source?: Maybe<string>
  utm_medium?: Maybe<string>
  utm_content?: Maybe<string>
  utm_campaign?: Maybe<string>
  utm_term?: Maybe<string>
  referred_by?: Maybe<string>
  referring_url?: Maybe<string>
  source_page?: Maybe<string>
}

export const getSource = ({
  gclid,
  utm_term,
  utm_source,
  utm_medium,
  referred_by,
  utm_content,
  utm_campaign,
  source_page,
  referring_url,
}: GetSourceParams): Maybe<string> => {
  const { __hstc, hubspotutk, _ga_82K54ZVGLB } = getCookies()

  const source =
    getURLSearch(
      {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        gclid,
        __hstc,
        hubspotutk,
        referred_by,
        _ga_82K54ZVGLB,
        referring_url: source_page || referring_url,
      },
      { decode: true },
    ) || null

  return source
}
